/**
 * @desc 获取文件详情
 */
import { OssFileDetail, OssDetailParam } from '@eastcoal/api/nexus/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryFileDetailParameter = OssDetailParam

const method = 'GET'
const url = '/nexus/oss/detail'

export const queryFileDetailApi = (
  params?: QueryFileDetailParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<OssFileDetail>({
    method,
    url,
    params,
    ...config
  })
}

queryFileDetailApi.method = method
queryFileDetailApi.url = url
